import { useSelector } from 'react-redux'
import { Loading } from '../../../../../common/loading'
import { Notification } from '../../../../../common/notification'
import { Layout } from '../../common/layout'
import { TitleChart } from '../../common/TitleChart'
import { AssetManagementEfficiencyTable } from './AssetManagementEfficiencyTable'
import { Chart } from './Chart'
import {
  selectActiveRowGroupId,
  selectIds,
  selectIsLoading,
  selectRowGroup,
} from './store/slice'

export const Content = () => {
  const activeRowGroupId = useSelector(selectActiveRowGroupId)
  const ids = useSelector(selectIds)
  const isLoading = useSelector(selectIsLoading)

  if (isLoading) {
    return (
      <div className="h100 positionRelative">
        <Loading />
      </div>
    )
  }

  if (!ids.length) {
    return <Notification />
  }

  return (
    <Layout
      renderLeft={() => <AssetManagementEfficiencyTable />}
      renderRight={() => <Chart />}
      renderTitle={() => (
        <TitleChart
          rowGroupId={activeRowGroupId}
          selectRowGroup={selectRowGroup}
        />
      )}
    />
  )
}
